import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-checkbox@2.1.6@rc-checkbox/es/index.js
// module id = 272
// module chunks = 0